import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { useSEO } from "../lib/useSEO";

export default function BestOf() {
  const [cats, setCats] = useState({ countries: [], states: [], cities: [] });

  useSEO({
    title: "Best waterfall guides by country, state & city | WaterfallFinder",
    description: "Browse the best waterfall guides organised by country, state and city. Find the perfect waterfall trip near you.",
  });

  useEffect(() => {
    (async () => {
      const r = await api.get("/categories");
      setCats(r.data);
    })();
  }, []);

  return (
    <main className="pt-16">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-10 pt-10">
        <h1 className="text-4xl md:text-5xl font-extrabold tracking-tight text-stone-900">
          Best waterfall <span className="heading-underline">guides</span>
        </h1>
        <p className="mt-4 text-stone-700 max-w-2xl">Pick a country, state or city to see hand-curated waterfall lists.</p>

        <Section title="By country" items={cats.countries.map((c) => ({ to: `/best-waterfalls-in/country/${c.slug}`, name: `Best waterfalls in ${c.name}`, count: c.count, key: c.slug }))} tid="bestof-country" />
        <Section title="By state / region" items={cats.states.map((s) => ({ to: `/best-waterfalls-in/state/${s.slug}`, name: `Best waterfalls in ${s.name}`, count: s.count, key: `${s.country_slug}-${s.slug}` }))} tid="bestof-state" />
        <Section title="By city / area" items={cats.cities.map((c, i) => ({ to: `/best-waterfalls-in/city/${c.slug}`, name: `Waterfalls in ${c.name}`, count: c.count, key: `${c.country}-${c.slug}-${i}` }))} tid="bestof-city" />
      </div>
    </main>
  );
}

function Section({ title, items, tid }) {
  if (!items?.length) return null;
  return (
    <div className="mt-12">
      <h2 className="text-2xl font-extrabold text-stone-900 mb-4">{title}</h2>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-2">
        {items.map((i, idx) => (
          <Link
            key={i.key}
            to={i.to}
            data-testid={`${tid}-${idx}`}
            className="text-stone-900 font-semibold hover:underline py-1"
          >
            {i.name}
            <span className="text-stone-500 font-normal"> ({i.count})</span>
          </Link>
        ))}
      </div>
    </div>
  );
}
